import { render } from "./ReferentialModalCreator.vue?vue&type=template&id=585136a8"
import script from "./ReferentialModalCreator.vue?vue&type=script&lang=js"
export * from "./ReferentialModalCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/admin/ReferentialModalCreator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "585136a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('585136a8', __exports__)) {
    api.reload('585136a8', __exports__)
  }
  
  module.hot.accept("./ReferentialModalCreator.vue?vue&type=template&id=585136a8", () => {
    api.rerender('585136a8', render)
  })

}


export default __exports__